import { render, staticRenderFns } from "./ZhanhuiNewsBlock.vue?vue&type=template&id=2423848c&scoped=true"
import script from "./ZhanhuiNewsBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiNewsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423848c",
  null
  
)

export default component.exports